import type { SVGProps } from 'react'

export const HomeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="22" height="22" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.5 18.3334V10.0001H11.5V18.3334M1.5 7.50008L9 1.66675L16.5 7.50008V16.6667C16.5 17.1088 16.3244 17.5327 16.0118 17.8453C15.6993 18.1578 15.2754 18.3334 14.8333 18.3334H3.16667C2.72464 18.3334 2.30072 18.1578 1.98816 17.8453C1.67559 17.5327 1.5 17.1088 1.5 16.6667V7.50008Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
